export const DEFAULT_TRUST = 1;
export const TRUST_MIN = 0;
export const TRUST_MAX = 1;
export const TRUST_PRECISION = 2;

export const parseTrustValue = (trust: string | number | null | undefined): number => {
    if (trust == null || trust === '') {
        return DEFAULT_TRUST;
    }

    const parsed = Number(trust);
    return Number.isFinite(parsed) ? parsed : DEFAULT_TRUST;
};

/** 归一化到两位小数 */
export const normalizeTrustValue = (trust: string | number | null | undefined): number =>
    Number(parseTrustValue(trust).toFixed(TRUST_PRECISION));

export const formatTrustValue = (trust: string | number | null | undefined): string =>
    normalizeTrustValue(trust).toFixed(TRUST_PRECISION);

/**
 * 清洗 Trust 输入：只保留数字和一个小数点，小数最多两位。
 * 字母等非数字会直接丢掉，不会写入输入框。
 */
export const sanitizeTrustInput = (raw?: string): string => {
    if (!raw) return '';

    let value = raw.replace(/[^\d.]/g, '');
    const firstDotIndex = value.indexOf('.');
    if (firstDotIndex !== -1) {
        value =
            value.slice(0, firstDotIndex + 1) + value.slice(firstDotIndex + 1).replace(/\./g, '');
    }

    const [intPart = '', decPart = ''] = value.split('.');
    if (value.includes('.')) {
        return `${intPart}.${decPart.slice(0, TRUST_PRECISION)}`;
    }

    return intPart;
};

export const isTrustNotDefault = (trust: string | number | null | undefined): boolean =>
    parseTrustValue(trust) !== DEFAULT_TRUST;

export const filterTrustNotDefault = <T extends { trust?: string | number | null }>(items: T[]): T[] =>
    items.filter((item) => isTrustNotDefault(item.trust));

export type TrustFilterMode = 'all' | 'notDefault';
